import React, { useEffect, useState } from 'react';

const COOKIE_KEY = 'cookie_consent';

export const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [choice, setChoice] = useState<string | null>(null);

  useEffect(() => {
    const savedChoice = localStorage.getItem(COOKIE_KEY);
    if (savedChoice) {
      setChoice(savedChoice);
      setVisible(false);
    } else {
      setVisible(true);
    }
  }, []);

  const handleConsent = (accept: boolean) => {
    localStorage.setItem(COOKIE_KEY, accept ? 'accepted' : 'rejected');
    setChoice(accept ? 'accepted' : 'rejected');
    setVisible(false);
    if (accept) {
      // Enable analytics or other non-essential cookies here
      window.dispatchEvent(new Event('cookie-accepted'));
    }
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full z-50 bg-stone-900 text-white p-4 shadow-lg flex flex-col md:flex-row items-center justify-between gap-4 animate-fade-in">
      <div className="flex-1 text-sm">
        Ce site utilise des cookies pour améliorer votre expérience. <a href="/cookie-policy" className="underline text-primary">En savoir plus</a>.
      </div>
      <div className="flex gap-2 mt-2 md:mt-0">
        <button
          className="bg-primary hover:bg-primary/80 text-white px-4 py-2 rounded"
          onClick={() => handleConsent(true)}
        >
          Accepter
        </button>
        <button
          className="bg-stone-700 hover:bg-stone-600 text-white px-4 py-2 rounded"
          onClick={() => handleConsent(false)}
        >
          Refuser
        </button>
      </div>
    </div>
  );
}; 